import { useEffect } from 'react';
import { HEADER_BUTTON_MODE } from '@hqo/hqo-miniapp-client-sdk';
import { useMiniappSdk } from 'app/shared/contexts/miniapp-sdk';

/**
 * Drive the NATIVE mobile shell header into history/back mode (blank title) + enable back-swipe for the
 * lifetime of a view. `enabled` is false on desktop hosts (they render an in-app back button instead).
 *
 * On unmount it resets the header to CLOSE mode (and disables back-swipe) — the miniapp ROOT needs a
 * close affordance to exit the miniapp; leaving it in history mode strands the user on the feed with a
 * back button that can't close the app.
 */
export const useNativeHistoryHeader = (enabled: boolean): void => {
  const sdk = useMiniappSdk();

  useEffect(() => {
    if (!enabled || !sdk?.header) {
      return undefined;
    }

    sdk.header.setHeader('', HEADER_BUTTON_MODE.HISTORY);
    sdk.header.showHeader();
    sdk.swipe?.enableBackSwipe?.();

    return () => {
      sdk.header?.setHeader('', HEADER_BUTTON_MODE.CLOSE);
      sdk.swipe?.disableBackSwipe?.();
    };
  }, [enabled, sdk]);
};
